import WarningIcon from './component'

export default WarningIcon
